import React, { useRef, lazy } from 'react';
import { MapPinIcon, PhoneIcon, ClockIcon, CalendarIcon, NavigationIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function LocationHours() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section id="location" className="w-full bg-[#141414] py-20 md:py-28 px-4" data-id="element-146">
      <div className="max-w-6xl mx-auto" data-id="element-147">
        {/* Header */}
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-148">
          <p className="text-[#c41e3a] font-semibold tracking-[0.25em] uppercase text-sm mb-3" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-149">
            Find Us
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-150">
            LOCATION & HOURS
          </h2>
          <div className="section-divider w-24 mx-auto" data-id="element-151" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-152">
          {/* Info Cards */}
          <div className="flex flex-col gap-5" data-id="element-153">
            {/* Address */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-6 flex items-start gap-4" data-id="element-154">
              <div className="flex-shrink-0 w-12 h-12 bg-[#c41e3a]/10 border border-[#c41e3a]/20 rounded-lg flex items-center justify-center text-[#c41e3a]" data-id="element-155">
                <MapPinIcon size={22} data-id="element-156" />
              </div>
              <div data-id="element-157">
                <h3 className="text-white font-bold text-lg mb-1" style={{
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '0.06em'
              }} data-id="element-158">
                  ADDRESS
                </h3>
                <p className="text-gray-300 text-base" data-id="element-159">2851 W 68 St Suite 11</p>
                <p className="text-gray-300 text-base" data-id="element-160">
                  Hialeah Gardens, FL 33018
                </p>
                <a href="https://maps.google.com/?q=2851+W+68+St+Suite+11+Hialeah+Gardens+FL+33018" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#c41e3a] hover:text-[#e02040] text-sm mt-2 transition-colors font-medium" aria-label="Get directions to Jonathan's Barbershop" data-id="element-161">
                  <NavigationIcon size={13} data-id="element-162" />
                  Get Directions
                </a>
              </div>
            </motion.div>

            {/* Phone */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-6 flex items-start gap-4" data-id="element-163">
              <div className="flex-shrink-0 w-12 h-12 bg-[#c41e3a]/10 border border-[#c41e3a]/20 rounded-lg flex items-center justify-center text-[#c41e3a]" data-id="element-164">
                <PhoneIcon size={22} data-id="element-165" />
              </div>
              <div data-id="element-166">
                <h3 className="text-white font-bold text-lg mb-1" style={{
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '0.06em'
              }} data-id="element-167">
                  PHONE
                </h3>
                <a href="tel:7864095863" className="text-gray-300 hover:text-white text-xl font-semibold transition-colors" aria-label="Call (786) 409-5863" data-id="element-168">
                  (786) 409-5863
                </a>
                <p className="text-gray-500 text-sm mt-1" data-id="element-169">
                  Call or text anytime
                </p>
              </div>
            </motion.div>

            {/* Hours */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-6 flex items-start gap-4" data-id="element-170">
              <div className="flex-shrink-0 w-12 h-12 bg-[#c41e3a]/10 border border-[#c41e3a]/20 rounded-lg flex items-center justify-center text-[#c41e3a]" data-id="element-171">
                <ClockIcon size={22} data-id="element-172" />
              </div>
              <div className="flex-1" data-id="element-173">
                <h3 className="text-white font-bold text-lg mb-3" style={{
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '0.06em'
              }} data-id="element-174">
                  HOURS
                </h3>
                <div className="flex flex-col gap-2" data-id="element-175">
                  <div className="flex justify-between items-center" data-id="element-176">
                    <span className="text-gray-400 text-sm" data-id="element-177">
                      Monday – Saturday
                    </span>
                    <span className="text-white font-medium text-sm" data-id="element-178">Open</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-179">
                    <span className="text-gray-400 text-sm" data-id="element-180">Sunday</span>
                    <span className="text-gray-500 text-sm" data-id="element-181">
                      Call to confirm
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 mt-3 pt-3 border-t border-[#2a2a2a]" data-id="element-182">
                  <span className="w-2 h-2 rounded-full bg-green-400" aria-hidden="true" data-id="element-183" />
                  <span className="text-green-400 text-sm font-medium" data-id="element-184">
                    Walk-ins Welcome
                  </span>
                </div>
              </div>
            </motion.div>

            {/* Appointments */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-6 flex items-start gap-4" data-id="element-185">
              <div className="flex-shrink-0 w-12 h-12 bg-[#c41e3a]/10 border border-[#c41e3a]/20 rounded-lg flex items-center justify-center text-[#c41e3a]" data-id="element-186">
                <CalendarIcon size={22} data-id="element-187" />
              </div>
              <div data-id="element-188">
                <h3 className="text-white font-bold text-lg mb-1" style={{
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '0.06em'
              }} data-id="element-189">
                  APPOINTMENTS
                </h3>
                <p className="text-gray-400 text-sm mb-3" data-id="element-190">
                  Skip the wait — book your spot in advance.
                </p>
                <a href="#book" className="inline-flex items-center gap-2 bg-[#c41e3a] hover:bg-[#a01830] text-white px-4 py-2 rounded text-sm font-semibold transition-colors" aria-label="Book your appointment" style={{
                fontFamily: 'Oswald, sans-serif',
                letterSpacing: '0.08em'
              }} data-id="element-191">
                  <CalendarIcon size={14} data-id="element-192" />
                  BOOK NOW
                </a>
              </div>
            </motion.div>
          </div>

          {/* Map embed */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="rounded-lg overflow-hidden border border-[#2a2a2a] min-h-[400px] lg:min-h-full" data-id="element-193">
            <iframe title="Jonathan's Barbershop Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3591.3!2d-80.3!3d25.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b8!2s2851+W+68+St+Suite+11%2C+Hialeah+Gardens%2C+FL+33018!5e0!3m2!1sen!2sus!4v1" width="100%" height="100%" style={{
            border: 0,
            minHeight: '400px',
            filter: 'invert(90%) hue-rotate(180deg)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" aria-label="Map showing Jonathan's Barbershop location at 2851 W 68 St Suite 11, Hialeah Gardens, FL 33018" data-id="element-194" />
          </motion.div>
        </div>
      </div>
    </section>;
}